import { useDrawer } from '@app/src/components/Drawer/DrawerContext'
import DrawerViewReferralContact from '@app/src/components/Drawer/Views/DrawerViewReferralContact'
import { ProvidersModalPurpose, useProvidersModal } from '@app/src/context/ProvidersModalContext'
import { useWriteAccess } from '@app/src/hooks/useWriteAccess'
import type { Provider } from '@app/src/types/organizations'
import { ProviderLinkStatus } from '@app/src/types/organizations'
import React from 'react'
import { useIntl } from 'react-intl'
import ButtonCell from './ButtonCell'
import type { ChipCellProps } from './ChipCell'
import ChipCell from './ChipCell'

export type ProviderConnectedCellProps = {
  provider: Provider
  disableCell?: boolean
} & ChipCellProps

const ProviderConnectedCell: React.FC<ProviderConnectedCellProps> = ({ provider, disableCell, ...props }) => {
  const { formatMessage } = useIntl()
  const { openDrawer } = useDrawer()
  const { handleOpenConnectDialog } = useProvidersModal()
  const hasWriteAccess = useWriteAccess()

  if (provider.linkStatus === ProviderLinkStatus.Connected) {
    return (
      <ChipCell
        label={formatMessage({ id: 'referral.inviteSent.connected' })}
        color="success"
        variant="filled"
        size="small"
        disableCell={disableCell}
        {...props}
      />
    )
  }

  if (provider.linkStatus === ProviderLinkStatus.Invited) {
    return (
      <ChipCell
        label={formatMessage({ id: 'referral.inviteSent.title' })}
        variant="filled"
        size="small"
        disableCell={disableCell}
        onClick={hasWriteAccess ? () => openDrawer(<DrawerViewReferralContact provider={provider} />) : undefined}
        {...props}
      />
    )
  }

  if (provider.linkStatus === ProviderLinkStatus.Created && !hasWriteAccess) {
    return (
      <ChipCell
        label={formatMessage({ id: 'referral.invitation.notConnected' })}
        variant="filled"
        size="small"
        disableCell={disableCell}
        {...props}
      />
    )
  }
  return (
    <ButtonCell
      size="small"
      label={formatMessage({ id: 'general.connect' })}
      variant="outlined"
      onClick={() => handleOpenConnectDialog([provider], ProvidersModalPurpose.InitialInvitation)}
      disableCell={disableCell}
    />
  )
}

export default ProviderConnectedCell
